import React, { Component } from 'react';
import { Modal, WhiteSpace, Button, Toast } from 'antd-mobile';
import { CommonlyHeadMembers } from '../../common/headnav';
import * as services from '../../projects/services';
import { AddPeople } from "../../common/addpeople";
import './style.less';
const alert = Modal.alert;
let mindex = 0;
export default class PeopleList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal1: false,
            sexlist: [],
            mlist: [],
            marriagelist: [],
            peoplelist: [],
            Bagid: 0,
            Marital: 0,
            Fullname: '',
            Idnumber: '',
            Mobile: '',
            PeopleId: 0,
            oneself:0,
            add:[],
        }

    }
    componentDidMount() {      
        services.GetPeopleList(null,'').then(data => {
            if (data.status === 0) {                
                this.setState({ peoplelist: data.result });               
            } else {
                Toast.offline(data.message);
            }
        })
        services.GetList('适用婚姻状况', '').then(data3 => {
            if (data3.status === 0) {
                let cm = [];
                data3.result.forEach((element, index) => {
                    if (index !== 0) {
                        element.name = element.name.substring(2, element.name.length);
                        let obj = {};
                        obj.value = element.code;
                        obj.label = element.name;
                        cm.push(obj);
                    }
                });

                this.setState({ marriagelist: cm });
            } else {
                Toast.offline(data3.message);
            }
        })     
     
     
    }
    issex = (key) => {
        if (parseInt(key) === null) {
            return key;
        } else if (parseInt(key) === 1) {
            return '男';
        } else {
            return '女';
        }
    }
    ismaritalstatus = (key) => {
        let value = this.state.marriagelist.find((p) => parseInt(p.value) === key);
        return !!value ? value.label : '';
    }
    del = (key) => {
        services.DelPeople(key, '正在删除请稍后').then(data => {
            if (data.status === 0) {
                Toast.success(data.message);
                this.GetPeopleList();
            } else {
                Toast.offline(data.message);
            }
        });
    }
    GetPeopleList() {
        services.GetPeopleList(null,'').then(data => {
            if (data.status === 0) {
                this.setState({ peoplelist: data.result });
            } else {
                Toast.offline(data.message);
            }
        });
    }
   
    onClose = () => {
        this.setState({modal1:false,add:[]});
       this.GetPeopleList();
    }
   
    onAdd = (e) => {
      this.setState({add:[],modal1:true});
    }
   
    onEdit = (data) => {
        this.setState({add:data,modal1:true});
    }
   

    render() {
        mindex++;
        const { peoplelist, sexlist, marriagelist } = this.state;


        
        return <div className="peoplebox">
             <CommonlyHeadMembers  barname={'体检人管理'} />
            {
                (!!peoplelist === false || peoplelist.length === 0) && mindex > 1 ? <div className="nothing">
                    <img alt='' src={require('../../../res/images/zwsj.png')} />
                    <p>当前体检人列表为空</p>
                    
                </div> :
                    !!peoplelist  && !!sexlist && !!marriagelist.length ?
                        peoplelist.map((data, index) => (
                            <div key={'p' + index}>
                                <WhiteSpace />
                                <div className="peoplelist" >
                                    <div className="prpole-info">
                                        <div className="info"><span className="name">{data.fullname}({!!data.bagname === false ?'?' : data.bagname})</span><span className="idcard">{data.idnumber}</span></div>
                                        <div className="info"><span className="tel">{data.mobile}</span><span className="sex">{this.issex(data.sex)}</span><span className="age">{data.age}</span><span className="age">{this.ismaritalstatus(data.maritalstatus)}</span></div>
                                    </div>
                                   
                                       
                                            <div className="prpole-but">
                                                <Button className="smallbut" size="small" inline
                                                    onClick={() => {
                                                        this.onEdit(data);
                                                    }}
                                                    
                                                >编辑</Button>

                                                {   parseInt(data.bagid) === 1 ? '' :<Button className="smallbut" size="small" inline
                                                    onClick={() =>
                                                        alert('删除提示', '确定删除体检人' + data.fullname + '吗?', [
                                                            { text: '不删了', onPress: () => {} },
                                                            { text: '确定删除', onPress: () => this.del(data.peopleid) },
                                                        ])
                                                    }
                                                >删除</Button>
                                                }
                                            </div>
                                    
                                </div>
                            </div>
                        ))
                        : ''
            }         
           
            <Modal
                visible={this.state.modal1}
                transparent
                closable={true}
                maskClosable={true}
                onClose={this.onClose}
                wrapProps={{ onTouchStart: this.onWrapTouchStart }}
            ><AddPeople onClose={this.onClose} data={this.state.add} />
            </Modal>
            <div className="footer">
                <div className="footerbox">
                    <Button className="inline-addbut" onClick={this.onAdd}>添加体检人</Button>
                </div>
            </div>
        </div >
    }
}